import { styled } from '@zenbusiness/zui/styles';

import { generateColors } from './utils';

export const StepStyle = ({ theme, status }) => {
  const colors = generateColors(theme);
  return {
    flex: '1',
    height: '2px',
    borderRadius: '2px',
    backgroundColor: colors[status]
  };
};

export const Step = styled('div', { shouldForwardProp: (prop) => prop !== 'status' })(StepStyle);
